import logger from 'logger';

import { getAuthClient } from './clients';

/**
 * Signs the user out server-side and replaces their tf-token with a fresh
 * anonymous one (Rails handles both). The endpoint is idempotent and always
 * returns 200; a non-2xx here means something unexpected went wrong (e.g.
 * network failure). Callers should still proceed with client-side cleanup
 * either way — the worst case is that a stale tf-token sticks around until
 * it expires.
 */
export async function logout(): Promise<
  { ok: true } | { ok: false; reason: 'unknown' }
> {
  const client = getAuthClient();
  try {
    await client.post('/logout');
    return { ok: true };
  } catch (err: any) {
    logger.error({
      msg: 'LogoutRequestFailed',
      noticable: err,
      extra: { context: { status: err?.response?.status } },
    });
    return { ok: false, reason: 'unknown' };
  }
}
